import { render, staticRenderFns } from "./MaterialPanel.vue?vue&type=template&id=5b465c03&scoped=true&"
import script from "./MaterialPanel.vue?vue&type=script&lang=js&"
export * from "./MaterialPanel.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPanel.vue?vue&type=style&index=0&id=5b465c03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b465c03",
  null
  
)

export default component.exports